import React from "react";
import { FormFieldSet, LoopFieldsSet, TableAdv } from "../../../../components";
import { Button } from "../../../../components";
import { Divider } from "../../../../components";
import { dateFormator, mapTableRows } from "../../../../utils";
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { fetchChecklists } from "../../../../redux/slices/onboarding/onboardingApi";
import { useState } from "react";
const ChecklistSettings = ({ checkListType }) => {
  const navigate = useNavigate();
  const [selectedCheckList, setSelectedCheckList] = useState([]);
  const [deletedRow, setDeletedRow] = useState([]);
  const [checklistData, setChecklistData] = useState({
    data: [],
    totalCount: 0,
  });
  console.log({ checklistData });

  const handleDelete = (id) => {
    setDeletedRow((prev) => [...prev, id]);
  };

  //
  const tableColumns = [
    { key: "name", label: "Checklist Name" },
    { key: "description", label: "Description", columnMenu: false },
    {
      key: "noofdocuments",
      label: "No of Documents",
      render: (row) => row?.documents?.length || "0",
    },
    {
      key: "createdBy",
      label: "Created By",
      render: (row) =>
        (row?.addedBy?.firstName || "") + " " + (row?.addedBy?.lastName || ""),
    },
    {
      key: "createdOn",
      label: "Created On",
      columnMenu: false,
      render: (row) => (row?.addedOn ? dateFormator(row?.addedOn) : ""),
    },
    {
      key: "actions",
      label: "Actions",
      columnMenu: false,
      render: (row) => (
        <div className="flex items-center">
          <Link
            to="/e-onboarding/editchecklist"
            state={{ checklistId: row.uiid, checkListType }}
          >
            <Button
              icon="edit_square"
              variant="text"
              color="error"
              className="!m-0 !p-1"
              size="sm"
            />
          </Link>
          <Button
            icon="delete"
            variant="text"
            color="error"
            className="!m-0 !p-1"
            size="sm"
            // onClick={() => console.log(`Delete Checklist ${row.id}`)}
            // onClick={() => handleDelete(row.id)}
          />
        </div>
      ),
    },
  ];

  // const extraColumnsMap = {
  //   Applicant:[],
  //   Vendor:[
  //     { key: "newList", label: "NewList" },
  //   ],
  //   Client:[],
  // }

  // const  newlyAddedColumns =[...tableColumns, ...extraColumnsMap[checkListType] || []]

  const fetchChecklistsForTable = async () => {
    try {
      const { data, totalCount } = await fetchChecklists({
        limit: 10,
        page: 1,
        ref: "AddedBy",
        filters: {
          entity: { type: "NONE", value: checkListType },
          // status: { type: "NONE", value: 1 },
        },
      });
      console.log({ data: data?.data, totalCount: totalCount?.data });
      setChecklistData({
        data: data?.data || [],
        totalCount: totalCount?.data,
      });
    } catch (error) {
      console.error("Error in fetchChecklistsForTable", error);
    }
  };
  useEffect(() => {
    fetchChecklistsForTable();
  }, [checkListType]);

  const rowData = Array.from({ length: 3 }, (_, i) => ({
    id: i + 1,
    checklistName: `Checklist ${i + 1}`,
    description: `Description for checklist ${i + 1}`,
    noofdocuments: Math.floor(Math.random() * 10) + 1,
    createdBy: `User ${i + 1}`,
    createdOn: new Date(2025, 10, i + 1).toLocaleDateString(),
    // actions: (
    //   <div className="flex items-center">
    //     <Button
    //       icon="edit_square"
    //       variant="text"
    //       color="error"
    //       className="!m-0 !p-1"
    //       size="sm"
    //       onClick={() => console.log(`Edit Checklist ${i + 1}`)}
    //     />
    //     <Button
    //       icon="delete"
    //       variant="text"
    //       color="error"
    //       className="!m-0 !p-1"
    //       size="sm"
    //       onClick={() => console.log(`Delete Checklist ${i + 1}`)}
    //     />
    //   </div>
    // ),
  }));
  // const mappedrows = mapTableRows(rowData, tableColumns);
  // testing woth api
  const mappedrows = mapTableRows(checklistData?.data || [], tableColumns);

  return (
    <div className="flex-1 flex">
      <div className="flex-1 flex p-2">
        <TableAdv
          columns={tableColumns}
          // columns={newlyAddedColumns}
          rows={mappedrows}
          showSlNo={false}
          showCheckbox={false}
          serverPagination={false}
          tableId={"checklistTable"}
          toolbarRight={{
            filter: true,
            add: [
              {
                component: (
                  <div className="flex items-center px-2  gap-3">
                    <div className="w-[300px]">
                      <FormFieldSet
                        noTitle
                        type="multiSelect"
                        placeholder="Select Checklist"
                        value={selectedCheckList}
                        onChange={(val) => setSelectedCheckList(val)}
                        options={[
                          { label: "Checklist1", value: 1 },
                          { label: "Checklist2", value: 2 },
                          { label: "Checklist3", value: 3 },
                          { label: "Checklist4", value: 4 },
                          { label: "Checklist5", value: 5 },
                        ]}
                      />
                    </div>
                    <Button title={"Show Archived"} variant="outlined" />
                    <Button
                      title={"Create Checklist"}
                      icon="add"
                      onClick={() =>
                        navigate("/e-onboarding/addchecklist", {
                          state: { checkListType },
                        })
                      }
                    />
                    <Divider orientation="vertical" className="ml-2 " />

                    <Button icon={"schedule"} color="black" variant="text" />
                  </div>
                ),
              },
            ],
          }}
        />
      </div>
    </div>
  );
};

export default ChecklistSettings;
